// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Vero Software components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function CaseStudyContent({ blocks }) {
  return (
    <MKBox mt={2}>
      {blocks.map((block, index) => {
        const key = `${block.type}-${index}`;

        if (block.type === "heading") {
          return (
            <MKTypography key={key} variant="subtitle2" fontWeight="bold" mt={2} mb={0.5}>
              {block.text}
            </MKTypography>
          );
        }

        if (block.type === "list") {
          return (
            <MKBox key={key} component="ul" pl={3} m={0} mb={1.5}>
              {block.items.map((item) => (
                <MKTypography key={item} component="li" variant="body2" color="text">
                  {item}
                </MKTypography>
              ))}
            </MKBox>
          );
        }

        return (
          <MKTypography key={key} variant="body2" color="text" mb={1.5}>
            {block.text}
          </MKTypography>
        );
      })}
    </MKBox>
  );
}

CaseStudyContent.propTypes = {
  blocks: PropTypes.arrayOf(
    PropTypes.shape({
      type: PropTypes.oneOf(["paragraph", "heading", "list"]).isRequired,
      text: PropTypes.string,
      items: PropTypes.arrayOf(PropTypes.string),
    })
  ).isRequired,
};

export default CaseStudyContent;
